import { createContext } from 'react';
import { Workflow } from '@lucidtech/las-sdk-browser';

export type FlowWorkflowContextValue = Workflow;

export const FlowWorkflowContext = createContext<FlowWorkflowContextValue | undefined>(undefined);
